import * as secondDashboardActions from '../secondCBILSDashboard/SecondCBILSDashboard.actions';

type TInitialState = {
    ready: boolean;
};

const initialState: TInitialState = {
    ready: false
};

type TActionTypes =
    | typeof secondDashboardActions.LEAVE_SECOND_CBILS_DASHBOARD
    | typeof secondDashboardActions.SECOND_CBILS_DASHBOARD_READY;

// eslint-disable-next-line import/no-default-export
export default function (state = initialState, action: { type: TActionTypes }) {
    switch (action.type) {
        case secondDashboardActions.SECOND_CBILS_DASHBOARD_READY:
            return {
                ...state,
                ready: true
            };
        case secondDashboardActions.LEAVE_SECOND_CBILS_DASHBOARD:
            return {
                ...state,
                ready: false
            };
        default:
            return state;
    }
}
